import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "005_repair_sales_invoice_resequence_markers",
  version: "1.4.1",
  ignoreErrors: [
    "no such table: accounting_sales_invoices",
    "no such table: sales_invoices",
    "no such table: sales_legacy_invoices_archive",
  ],
  sql: `
WITH marker_candidates AS (
  SELECT
    \`id\`,
    \`company_id\`,
    COALESCE(NULLIF(substr(\`invoice_date\`, 1, 4), ''), strftime('%Y', 'now')) AS doc_year,
    \`invoice_date\`,
    \`created_at\`
  FROM \`accounting_sales_invoices\`
  WHERE \`invoice_type\` = 'sales'
    AND \`party_type\` = 'customer'
    AND \`invoice_no\` GLOB '__SINV_RESEQ__*'
    AND \`deleted_at\` IS NULL
),
existing AS (
  SELECT
    substr(\`invoice_no\`, 6, 4) AS doc_year,
    MAX(CAST(substr(\`invoice_no\`, 11) AS INTEGER)) AS max_seq
  FROM \`accounting_sales_invoices\`
  WHERE \`invoice_type\` = 'sales'
    AND \`invoice_no\` LIKE 'SINV-%'
    AND length(\`invoice_no\`) = 15
    AND \`id\` NOT IN (SELECT \`id\` FROM marker_candidates)
  GROUP BY substr(\`invoice_no\`, 6, 4)
),
numbered AS (
  SELECT
    marker_candidates.\`id\`,
    'SINV-' || marker_candidates.doc_year || '-' || printf(
      '%05d',
      COALESCE(existing.max_seq, 0)
        + ROW_NUMBER() OVER (
          PARTITION BY marker_candidates.doc_year
          ORDER BY marker_candidates.\`invoice_date\`, marker_candidates.\`created_at\`, marker_candidates.\`id\`
        )
    ) AS new_invoice_no
  FROM marker_candidates
  LEFT JOIN existing ON existing.doc_year = marker_candidates.doc_year
)
UPDATE \`accounting_sales_invoices\`
SET
  \`invoice_no\` = (SELECT numbered.new_invoice_no FROM numbered WHERE numbered.\`id\` = \`accounting_sales_invoices\`.\`id\`),
  \`updated_at\` = strftime('%Y-%m-%dT%H:%M:%fZ', 'now')
WHERE \`id\` IN (SELECT \`id\` FROM numbered);

UPDATE \`sales_legacy_invoices_archive\`
SET
  \`invoice_no\` = (
    SELECT \`accounting_sales_invoices\`.\`invoice_no\`
    FROM \`accounting_sales_invoices\`
    WHERE \`accounting_sales_invoices\`.\`id\` = \`sales_legacy_invoices_archive\`.\`id\`
  ),
  \`updated_at\` = strftime('%Y-%m-%dT%H:%M:%fZ', 'now')
WHERE \`invoice_no\` GLOB '__SINV_RESEQ__*'
  AND \`id\` IN (
    SELECT \`id\`
    FROM \`accounting_sales_invoices\`
    WHERE \`invoice_no\` LIKE 'SINV-%'
      AND length(\`invoice_no\`) = 15
  );

UPDATE \`sales_invoices\`
SET
  \`invoice_no\` = (
    SELECT \`accounting_sales_invoices\`.\`invoice_no\`
    FROM \`accounting_sales_invoices\`
    WHERE \`accounting_sales_invoices\`.\`id\` = \`sales_invoices\`.\`id\`
  ),
  \`updated_at\` = strftime('%Y-%m-%dT%H:%M:%fZ', 'now')
WHERE \`invoice_no\` GLOB '__SINV_RESEQ__*'
  AND \`id\` IN (
    SELECT \`id\`
    FROM \`accounting_sales_invoices\`
    WHERE \`invoice_no\` LIKE 'SINV-%'
      AND length(\`invoice_no\`) = 15
  );

WITH current_year_max AS (
  SELECT
    \`company_id\`,
    COALESCE(MAX(CAST(substr(\`invoice_no\`, 11) AS INTEGER)), 0) AS max_seq
  FROM \`accounting_sales_invoices\`
  WHERE \`invoice_type\` = 'sales'
    AND substr(\`invoice_no\`, 6, 4) = strftime('%Y', 'now')
    AND \`invoice_no\` LIKE 'SINV-%'
    AND length(\`invoice_no\`) = 15
    AND \`deleted_at\` IS NULL
  GROUP BY \`company_id\`
),
global_current_year_max AS (
  SELECT COALESCE(MAX(max_seq), 0) AS max_seq FROM current_year_max
),
series_targets AS (
  SELECT
    \`core_numbering_series\`.\`id\`,
    CASE
      WHEN \`core_numbering_series\`.\`company_id\` IS NULL THEN (SELECT max_seq FROM global_current_year_max)
      ELSE COALESCE(
        (
          SELECT current_year_max.max_seq
          FROM current_year_max
          WHERE current_year_max.\`company_id\` = \`core_numbering_series\`.\`company_id\`
        ),
        0
      )
    END AS max_seq
  FROM \`core_numbering_series\`
  WHERE \`module\` = 'accounting'
    AND \`doctype\` = 'sales_invoice'
    AND \`is_default\` = 1
)
UPDATE \`core_numbering_series\`
SET
  \`prefix\` = 'SINV-{YYYY}-#####',
  \`current_value\` = CASE
    WHEN \`current_value\` < (SELECT max_seq FROM series_targets WHERE series_targets.\`id\` = \`core_numbering_series\`.\`id\`)
      THEN (SELECT max_seq FROM series_targets WHERE series_targets.\`id\` = \`core_numbering_series\`.\`id\`)
    ELSE \`current_value\`
  END,
  \`reset_every\` = 'yearly',
  \`last_reset_year\` = CAST(strftime('%Y', 'now') AS INTEGER),
  \`updated_at\` = strftime('%Y-%m-%dT%H:%M:%fZ', 'now')
WHERE \`id\` IN (SELECT \`id\` FROM series_targets)
  AND (
    \`prefix\` <> 'SINV-{YYYY}-#####'
    OR \`reset_every\` <> 'yearly'
    OR \`current_value\` < (SELECT max_seq FROM series_targets WHERE series_targets.\`id\` = \`core_numbering_series\`.\`id\`)
  );
  `.trim(),
};
